import React, { useCallback } from 'react';
import "./deleteProfileModal.css"
import { useDispatch, useSelector } from 'react-redux';
import { deleteProfile } from '../../api/apiHandler';
import { deleteUserProfile } from '../../slices/authSlice';
import { useTranslation } from 'react-i18next';
import '../../i18'; 

const DeleteProfileModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    const userInfo = useSelector((state) => state.auth.userInfo);

    const dispatch = useDispatch()

    const handleDeleteProfile = useCallback(
        async () => {
            deleteProfile({ id: userInfo.id })
                .then((response) => {
                    if (response.code == 200) {
                        dispatch(deleteUserProfile());
                    }
                });
                onClose();
        }
    )
    if (!isOpen) return null;
    return (
        <>
            <div className="DeleteAccountOverlay">
                <div
                    id="DeleteAccount"
                    tabIndex={-1}
                    aria-hidden="true"
                    className="modal-dialog modal-dialog-centered"
                >
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h6 className="modal-title">{t('deleteProfileModalHeading')}</h6>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <p className="DeleteModaltext">
                                {t('confirmDelete')}
                            </p>
                        </div>
                        <div className="modal-footer border-0 d-flex justify-content-center gap-4">
                            <button
                                className="ModalYesLink"
                                onClick={handleDeleteProfile}
                            >
                                {t('delete')}
                            </button>
                            <button
                                className="ModalNoLink"
                                onClick={onClose}
                            >
                                {t('no')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeleteProfileModal;
